<template>
  <section id="subPage">
    <div class="container contDetails">
      <div class="row">
        <div class="col-md-4">
          <div class="leftBlockMenu">
            <h2>Hizmetler</h2>
            <ul>
              <li><a href="/bireysel-kiralama-hizmeti" title=""><i class="fas fa-long-arrow-alt-right"></i>Bireysel Kiralama Hizmeti</a></li>
              <li class="active"><a href="/kurumsal-kiralama-hizmeti" title=""><i class="fas fa-long-arrow-alt-right"></i>Kurumsal Kiralama Hizmeti</a></li>
              <li><a href="/bayimiz-olun" title=""><i class="fas fa-long-arrow-alt-right"></i>Bayilik Hizmeti</a></li>
            </ul>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="col-md-8 cont contProfil">
          <nav class="navbar navbar-expand-lg navbar-light">
            <a class="navbar-brand" href="#">KURUMSAL KİRALAMA HİZMETİ</a>
            <div class="collapse navbar-collapse" id="navbarNav">
              <ul class="navbar-nav">
                <li class="nav-item active"><router-link to="/" class="nav-link">Ana Sayfa <span class="sr-only">(current)</span></router-link></li>
                <!-- <li class="nav-item"><a class="nav-link" href="#">Örnek</a></li> -->
                <li class="nav-item"><a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Profilim</a></li>
              </ul>
            </div>
          </nav>

          <div class="row">
            <div class="col-md-12">

              <p><strong> Kurumsal araç kiralamada kaliteli hizmet ve hızlı çözüm arıyorsanız, ihtiyacınızı karşılamak için buradayız.</strong></p>
              <p>Kurumsal müşterilerimizin günlük araç kiralama taleplerini; çağrı merkezi ve e-posta yolu ile yapılan taleplerle karşılanmaktayız. Araçların teslimatı Türkiye çapında standart hizmet sunan şubelerimizden gerçekleşmektedir.</p>
              <p>Kurumsal müşterilerimize sunduğumuz özel cazip indirim oranları ve esnek çalışma koşulları, müşterilerimiz için ayrıcalıklı avantajlar yaratmaktadır.</p>
              <p>Kurumsal kiralama hizmetimiz hakkındaki sorularınız ve talepleriniz için <strong>kurumsalkiralama@popycar.com</strong> adresinden bize mail atabilir veya <strong>444 5 649</strong> çağrı merkezimizden bizlere ulaşabilirsiniz.</p>
              </div>
          </div>

          <div class="row">
        <div class="col-md-12">


          <p style="margin-top:30px;font-weight:bold;">Kurumsal Kiralama Talepleriniz İçin: kurumsalkiralama@popycar.com</p>

        </div>
      </div>

        </div>
      </div>


    </div>
  </section>

</template>

<script>
    export default {
        name: "services",
        metaInfo: () => ({
    title: 'Kurumsal Kiralama Hizmeti',
    titleTemplate: '%s - PopyCar',
    htmlAttrs: {
      lang: 'tr',
      amp: true
    },
    meta: [
      { name: 'description', content: "Kurumsal araç kiralama ihtiyaçlarınız için kaliteli hizmet ve hızlı çözüm PopyCar'da! Bize ulaşın, çözüm ortağınız olarak her zaman yanınızdayız! " }
    ]
  })
  }
</script>

<style scoped>
.btnGray{
    padding: 10px 18px 0px 18px !important;
    text-decoration: none !important;
  }
  .btnRed{
    padding: 10px 18px 0px 18px !important;
    text-decoration: none !important;
  }
</style>
